import { useEffect, useState } from "react";
import { get, can, getOrganizationId } from "@/utils/service";

export interface MemberOption { id: string; name: string; email: string }

let cache: { org: string | null; members: Promise<MemberOption[]> } | null = null;

/** Active members of the organization (for owner / assignee pickers). */
export function useMemberOptions(): MemberOption[] {
  const [members, setMembers] = useState<MemberOption[]>([]);
  useEffect(() => {
    if (!can("members.view")) return;
    const org = getOrganizationId();
    if (!cache || cache.org !== org) {
      cache = {
        org,
        members: get<{ data: { members: Array<{ status: string; user: { id: string; first_name: string; last_name: string; email: string } }> } }>("/members")
          .then((r) => r.data.members.filter((m) => m.status === "active").map((m) => ({ id: m.user.id, name: `${m.user.first_name} ${m.user.last_name}`, email: m.user.email })))
          .catch(() => { cache = null; return []; }),
      };
    }
    let live = true;
    cache.members.then((m) => live && setMembers(m));
    return () => { live = false; };
  }, []);
  return members;
}
